import { render } from "./InfoBanner.vue?vue&type=template&id=34f3cdfd&scoped=true&ts=true"
import script from "./InfoBanner.vue?vue&type=script&lang=ts"
export * from "./InfoBanner.vue?vue&type=script&lang=ts"

import "./InfoBanner.vue?vue&type=style&index=0&id=34f3cdfd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f3cdfd"]])

export default __exports__